const Resources = {

    table_headers: [
        { 
          text:     'Walking #',
          value:    'walking_number'
        },
        { 
            text:   'Door #',
            value:  'door_number'
        },
        { 
            text:   'Description',
            value:  'sort_desc',
            type:   ''
        },
        { 
            text:   'Sq feet',
            value:  'sq_ft'
        },
        { 
            text:   'Area',
            value:  'area'
        },
        {   
            text:   'DailyTask(s)',
            value:  'daily_tasks',
            type: 'tasks'
        },
        {   
            text:   'PolicingTask(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
        },
        {   
            text:   'ProjectTask(s)',
            value:  'project_tasks',
            type:   'tasks',
            class:  'header-orange',
        },
    ],

    validation_table_headers: [
        { 
            text:     'Room',
            value:    'room'
        },
        { 
            text:   'Error',
            value:  'error'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Utilities',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Mass Add Codes',
            href:   '/utilities-project-codes-mass-add',
            arrow:  "",
        },
    ],

}

export default Resources;